import { ProductImpressionTrackingInfo } from "@services/tracking/types/trackingInfo/productImpressionTrackingInfo";

export interface GoogleAnalyticsProduct {
    name: string;
    category?: string;
    id: string;
    price: number;
    discount: number | string;
    tax: string;
    currencyCode: string;
    variant?: string;
    brand: string;
    ean?: string | null;

    // in a list:
    list?: string;
    listTitle?: string;
    placement?: number;

    // in cart
    quantity?: number;
}

const getGoogleAnalyticsProduct = (
    product: ProductImpressionTrackingInfo,
): GoogleAnalyticsProduct => {
    return {
        name: product.name,
        category: product.category,
        id: product.id,
        ean: product.ean,
        price: product.unitPrice,
        discount: product.reduction,
        currencyCode: product.currencyCode,
        tax: product.tax,
        list: product.list,
        listTitle: product.listTitle,
        placement: product.placement,
        brand: product.brand,
    };
};

export { getGoogleAnalyticsProduct };
